import styled from 'styled-components';
export const SettingItem = styled.div `
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  padding: var(--space-400);
  background-color: var(--bg-secondary);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
`;
export const SettingItemHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;
export const SettingInfo = styled.div `
  flex: 1;
`;
export const SettingName = styled.div `
  font-weight: var(--font-weight-semibold);
  margin-bottom: var(--space-100);
  color: var(--text-primary);
`;
export const SettingType = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-200);
  text-transform: uppercase;
  margin-bottom: var(--space-100);
`;
export const SettingId = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-200);
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  margin-top: var(--space-50);
`;
export const SettingActions = styled.div `
  display: flex;
  gap: var(--space-200);
`;
export const DragHandle = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: grab;
  color: var(--icon-secondary);
  margin-top: var(--space-400);

  &:active {
    cursor: grabbing;
  }

  &:hover {
    color: var(--text-primary);
  }
`;
export const EditHandle = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: grab;
  color: var(--icon-secondary);
  margin-top: var(--space-400);
`;
